import {Heading, Stack} from '@chakra-ui/react';
import React from 'react';
import {fontFamily, getWorldTypeAccentColor} from './config';
import {getCoverContent} from './coverContent';
import PublicWorldsList from './PublicWorldsList';

const CurrentWorldType = ({
  currentWorld,
  onNewWorldClick,
  onWorldClick,
  worldType,
  worlds,
}) => {
  const content = getCoverContent(worldType);
  const accentColor = getWorldTypeAccentColor({
    rules: {
      worldType,
    },
  });

  return (
    <Stack
      border={`4px solid ${accentColor}`}
      bg="black"
      color="white"
      fontFamily={fontFamily}
      gap={2}
      h="full"
      justifyContent="center"
      minH={0}
      overflow="hidden"
      p={4}
    >
      <Heading
        color={accentColor}
        fontFamily={fontFamily}
        letterSpacing="0.1em"
        size="lg"
        textTransform="uppercase"
        textAlign="center"
      >
        {content.title}
      </Heading>

      <PublicWorldsList
        currentWorld={currentWorld}
        onNewWorldClick={onNewWorldClick}
        onWorldClick={onWorldClick}
        worldType={worldType}
        worlds={worlds}
      />
    </Stack>
  );
};

export default CurrentWorldType;
